export const textStyled = {
    styleOverrides: {
        root: {
            color: "#4F4F56",
            fontFamily: "'Montserrat'",
            fontSize: 14,
            "& h2": {
                fontFamily: "'Montserrat'",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "110%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "34px", // Desktop up
                },
            },
            "& h3": {
                fontFamily: "'Montserrat'",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "113%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "28px", // Desktop up
                },
            },
            "& h4": {
                fontFamily: "'Montserrat'",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "117%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "24px", // Desktop up
                },
            },
            "& h5": {
                fontFamily: "'Montserrat'",
                fontWeight: 700,
                fontSize: "18px",
                lineHeight: "117%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "20px", // Desktop up
                },
            },
            "& h6": {
                fontFamily: "'Montserrat'",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "125%",
                letterSpacing: "0.02em",
            },
            "& a": {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "none",
            },
            "& p": {
                margin: 0,
                lineHeight: "150%",
            },
            "& pre": {
                whiteSpace: "pre-wrap",
            },
            "&  ul.todo-list": {
                listStyle: "none",
                pl: "22px",
                "& li": {
                    listStyle: "none",
                    textIndent: "-22px",
                    "&:not(:last-child)": {
                        mb: 1.5,
                    },
                    "&:before": {
                        content: `"\\f00c"`,
                        fontWeight: "400",
                        fontSize: "14px",
                        verticalAlign: "middle",
                        textIndent: "0",
                        width: "22px",
                        display: "inline-block",
                        fontFamily: `"Font Awesome 5 Pro"`,
                        color: "#007F00",
                    },
                    "& ul": {
                        ml: 3,
                        "& li": {
                            textIndent: "-22px",
                            "&:before": {
                                content: `"\\f00c"`,
                                fontWeight: "400",
                                fontSize: "14px",
                                width: "22px",
                                color: "secondary.main",
                            },
                        },
                    },
                },
            },
        },
    },
};
